<template>
    <component :style="getWidth"
               :is="component"
               :value="value"
               :options="options"
               :type="type"
               :id="id"
               @enter="$emit('enter')"
               @input="$emit('input', $event)"
               @focus="$emit('focus')"
               @blur="$emit('blur')"
               @invalid="$emit('invalid', $event)">
    </component>
</template>

<script>
    import SimpleInput from "./SimpleInput";
    import DateField from "./DateField";
    import SelectField from "./SelectField";
    import TextareaField from "./TextareaField";
    import ResizableTextarea from "./ResizableTextarea";
    import FileField from "./FileField";
    import RadioList from "./RadioList";
    import GroupField from "./GroupField";
    import {GROUP, SELECT, DATE, FILE, RADIO_LIST, TEXTAREA} from "../../../constants/common"

    export default {
        name: 'input-field',

        components: {
            GroupField,
            RadioList,
            FileField,
            TextareaField,
            SelectField,
            DateField,
            SimpleInput
        },
        computed: {
            getWidth() {
                const opt = this.options;
                let width = opt ? opt.width : 100;
                return width ? 'width:' + width + '%' :''
            }
        },
        props: {
            id: String,
            type: String,
            value: undefined,
            options: Object,
        },
        methods: {
            /*inputHandler(e) {
                this.$emit('input', e.target.value)
            }*/
            defineComponent(type) {
                switch(type) {
                    case DATE:
                        return DateField;
                    case SELECT:
                        return SelectField;
                    case FILE:
                        return FileField;
                    case RADIO_LIST:
                        return RadioList;
                    case TEXTAREA:
                        return ResizableTextarea;
                    case GROUP:
                        return GroupField;
                    default:
                        return SimpleInput
                }
            },


        },
        created() {
            let type = this.type ? this.type : 'text';
            this.component = this.defineComponent(type)
        }

    }
</script>


<style scoped>

</style>
